<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Configurações de Campanhas</h2>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>{{ item?.Campaign?.Name || 'Sem Campanha' }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="cube-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Módulo</span>
                                    <span class="detail-value">{{ item?.Module?.Name }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.Status ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.Status"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Estado</span>
                                    <span class="detail-value">{{ item?.Status ? 'Ativo' : 'Inativo' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="calendar-number-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Validade (dias)</span>
                                    <span class="detail-value">{{ item?.CampaignValidationDays }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="cash-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Valor Mínimo Fatura</span>
                                    <span class="detail-value">{{ item?.MinimumInvoiceValue }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="gift-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Benefício</span>
                                    <span class="detail-value">
                                        {{ item?.BenefitValue }} {{ item?.BenefitValueInPercentage ? '%' : '' }}
                                        (Moeda: {{ item?.BenefitCurrency }})
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="ticket-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Vouchers Disponíveis</span>
                                    <span class="detail-value">
                                        {{ item?.MaxAvailableVouchersToIssue }} (Total) /
                                        {{ item?.MaxAvailableVouchersByUser }} (por utilizador)
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>

        </ion-row>
    </ion-grid>
</ion-col>
